 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"home":"home","explain":"explain","feedback":"feedback","switch":"switch","transfer":"transfer"}[chunkId]||chunkId) + "." + {"chunk-04c3c40f":"31b8ac4e","chunk-0df2229c":"6b48c658","chunk-0f01ccc0":"5eaef662","chunk-1163e566":"bf918bea","chunk-12779c8f":"590b9375","chunk-17326af0":"92c006d0","chunk-24570e6f":"9043b420","chunk-30ab879c":"06c0a804","chunk-3f7104b2":"5728c7fb","chunk-47c15018":"14510e80","chunk-6e714126":"f0a3a311","chunk-4bd747bd":"3b0422d3","chunk-526b8466":"71909d96","chunk-3299d969":"229efa18","chunk-6f09dfb2":"b6fcf7d6","chunk-79debab8":"683ec4bb","chunk-5b8e6004":"ed0cbd17","chunk-5fe79acd":"0258fe92","chunk-671112c6":"564eb832","chunk-6ca61a78":"3425bf9d","chunk-6fac3796":"8d0fbae9","chunk-7479607a":"a090c99d","chunk-77f7649c":"1a394d31","chunk-7b95d250":"180ddafc","chunk-7bdae556":"6f9ca52f","chunk-7dc7271f":"3376a3bb","chunk-7dcb5aa1":"6276bc79","chunk-8d250c9c":"99cae373","chunk-9478157e":"d18f8aee","chunk-9494a048":"6df83e4c","chunk-b0e36a82":"7c782101","chunk-c8b17cf4":"1fd0c227","chunk-cca4ed70":"621957aa","chunk-e982a3b8":"4d0afe57","chunk-02abb509":"b4750687","chunk-29eebde6":"752ff370","chunk-3c7dacae":"622a1d1a","home":"9cb79364","chunk-ef47df72":"fbaa1974","chunk-f151752c":"b9aee36e","explain":"7fdb89a0","feedback":"afa9efef","switch":"1e5443c7","transfer":"2af33100"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-04c3c40f":1,"chunk-0df2229c":1,"chunk-0f01ccc0":1,"chunk-1163e566":1,"chunk-12779c8f":1,"chunk-17326af0":1,"chunk-24570e6f":1,"chunk-30ab879c":1,"chunk-3f7104b2":1,"chunk-47c15018":1,"chunk-6e714126":1,"chunk-4bd747bd":1,"chunk-3299d969":1,"chunk-6f09dfb2":1,"chunk-79debab8":1,"chunk-5b8e6004":1,"chunk-5fe79acd":1,"chunk-671112c6":1,"chunk-6ca61a78":1,"chunk-6fac3796":1,"chunk-7479607a":1,"chunk-77f7649c":1,"chunk-7b95d250":1,"chunk-7bdae556":1,"chunk-7dc7271f":1,"chunk-7dcb5aa1":1,"chunk-8d250c9c":1,"chunk-9478157e":1,"chunk-9494a048":1,"chunk-b0e36a82":1,"chunk-c8b17cf4":1,"chunk-cca4ed70":1,"chunk-02abb509":1,"chunk-29eebde6":1,"chunk-3c7dacae":1,"home":1,"chunk-ef47df72":1,"chunk-f151752c":1,"explain":1,"feedback":1,"switch":1,"transfer":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"home":"home","explain":"explain","feedback":"feedback","switch":"switch","transfer":"transfer"}[chunkId]||chunkId) + "." + {"chunk-04c3c40f":"49b761b1","chunk-0df2229c":"2036c856","chunk-0f01ccc0":"35361a18","chunk-1163e566":"db7bf768","chunk-12779c8f":"3e3d1fc3","chunk-17326af0":"20b880f4","chunk-24570e6f":"4a4c6f11","chunk-30ab879c":"8421f073","chunk-3f7104b2":"cc2dea25","chunk-47c15018":"47649055","chunk-6e714126":"8b65c37d","chunk-4bd747bd":"2d23caf1","chunk-526b8466":"31d6cfe0","chunk-3299d969":"14853371","chunk-6f09dfb2":"e790b552","chunk-79debab8":"9b80b21d","chunk-5b8e6004":"6e3be09e","chunk-5fe79acd":"45f083f8","chunk-671112c6":"09276e21","chunk-6ca61a78":"b7ea1421","chunk-6fac3796":"1185e746","chunk-7479607a":"523a4cf6","chunk-77f7649c":"978b6430","chunk-7b95d250":"a0899c01","chunk-7bdae556":"0649e71f","chunk-7dc7271f":"df5118d4","chunk-7dcb5aa1":"b485a2d0","chunk-8d250c9c":"00e7067b","chunk-9478157e":"f089f52a","chunk-9494a048":"084eabb6","chunk-b0e36a82":"71d7700c","chunk-c8b17cf4":"16ef9273","chunk-cca4ed70":"c232448b","chunk-e982a3b8":"31d6cfe0","chunk-02abb509":"685bab25","chunk-29eebde6":"0574c204","chunk-3c7dacae":"60c71d06","home":"546bc8ea","chunk-ef47df72":"5ae0162a","chunk-f151752c":"54a7a5d2","explain":"908deffb","feedback":"bc66c11b","switch":"3a631c04","transfer":"1554f985"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
